"use client";

import Link from "next/link";
import {
  Dispatch,
  RefObject,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import cn from "@/utils/class-names";
import { Popover } from "@/components/ui/popover";
import { Title, Text } from "@/components/ui/text";
import { Avatar } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { routes } from "@/config/routes";
import { useMedia } from "@/hooks/use-media";
import SimpleBar from "@/components/ui/simplebar";
import { PiCheck } from "react-icons/pi";
import { FaRocketchat } from "react-icons/fa6";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import { putNotifSeen } from "@/functions/axios/notification/putNotifSeen";
import { produce } from "immer";
import GetDate from "@/functions/GetDate";
type StateType = {
  data: any[] | undefined;
  loading: boolean;
  error: any | null;
};

function MessagesList({
  setIsOpen,
  data,
  setData,
  setSeen,
}: {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: StateType;
  setData: Dispatch<SetStateAction<StateType>>;
  setSeen: Dispatch<SetStateAction<boolean>>;
}) {
  const axiosAuth = useAxiosAuth();
  return (
    <div className="w-[320px] text-left rtl:text-right sm:w-[360px] 2xl:w-[420px]">
      <div className="mb-2 flex items-center justify-between ps-6">
        <Title as="h5">پیام ها</Title>
        {/* <Link
          href={routes.support.inbox}
          onClick={() => setIsOpen(false)}
          className="hover:underline"
        >
          View all
        </Link> */}
      </div>
      <SimpleBar className="max-h-[420px]">
        {data.data && (
          <div className="grid cursor-pointer grid-cols-1 gap-1 ps-4">
            {data.data.filter((item) => item.status == "chat").length <= 0 && (
              <p>پیامی برای شما وجود ندارد.</p>
            )}
            {data.data
              .filter((item) => item.status == "chat")
              .map((item: any, index: number) => (
                <Link href={routes.chat(item.chatroom)} key={index}>
                  <div
                    onClick={async () => {
                      var val = await putNotifSeen(axiosAuth, item.id);
                      
                      // setData(x=>{return produce(x,(draftstate)=>{})})
                      setIsOpen(false);
                      setData((x) => {
                        return produce(x, (draft) => {
                          if (draft.data && data.data) {
                            draft.data[
                              data.data.findIndex(
                                (findItem) => findItem.id == item.id
                              )
                            ].is_seen = true;
                          }
                        });
                      });
                    }}
                    key={item.status + item.id}
                    className="group grid grid-cols-[auto_minmax(0,1fr)] gap-3 rounded-md px-2 py-2 pe-3 transition-colors hover:bg-gray-100 dark:hover:bg-gray-50"
                  >
                    <div className="flex h-9 w-9 items-center justify-center rounded bg-gray-100/70 p-1 dark:bg-gray-50/50 [&>svg]:h-auto [&>svg]:w-5">
                      {/* {item.status} */}
                      {/* {getStatusBadge(item.status)} */}
                      <FaRocketchat />
                    </div>
                    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center">
                      <div className="w-full">
                        <Title
                          as="h6"
                          className="mb-0.5 w-11/12 truncate text-sm font-semibold"
                        >
                          {item.message}
                        </Title>
                        <span className="ms-auto whitespace-nowrap pe-8 text-xs text-gray-500">
                          {/* @ts-ignore */}
                          {/* {dayjs(item.create_date).fromNow(true)} */}
                          <GetDate create_date={item.create_date}></GetDate>

                        </span>
                      </div>
                      <div className="ms-auto flex-shrink-0">
                        {item.is_seen ? (
                          <span className="inline-block rounded-full bg-gray-100 p-0.5 dark:bg-gray-50">
                            <PiCheck className="h-auto w-[12px]" />
                          </span>
                        ) : (
                          <Badge
                            renderAsDot
                            size="lg"
                            color="info"
                            className="scale-90"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        )}
      </SimpleBar>
    </div>
  );
}

export default function MessagesDropdown({
  children,
  data,
  setData,
  setSeen,
}: {
  children: JSX.Element & { ref?: RefObject<any> };
  data?: StateType;
  setData?: Dispatch<SetStateAction<StateType>>;
  setSeen?: Dispatch<SetStateAction<boolean>>;
}) {
  const isMobile = useMedia("(max-width: 480px)", false);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      content={() => (
        <MessagesList
          data={data ? data : { data: undefined, loading: false, error: null }}
          setIsOpen={setIsOpen}
          setData={setData ? setData : () => {}}
          setSeen={setSeen ? setSeen : () => {}}
        />
      )}
      shadow="sm"
      placement={isMobile ? "bottom" : "bottom-end"}
      className="z-50 pb-6 pe-6 ps-0 pt-5 dark:bg-gray-100 [&>svg]:hidden [&>svg]:dark:fill-gray-100 sm:[&>svg]:inline-flex"
    >
      {children}
    </Popover>
  );
}

{
  /* <SimpleBar className="max-h-[406px]">
{data.data &&<div className="grid cursor-pointer grid-cols-1 gap-1 ps-4">
  {data.data.filter(item => item.status == "chat").map((item) => (
    <div
      key={item.name + item.id}
      className="group grid cursor-pointer grid-cols-[auto_minmax(0,1fr)] gap-2.5 rounded-md px-2 py-2.5 pe-3 transition-colors hover:bg-gray-100 dark:hover:bg-gray-50"
    >
      <div className={cn("relative", item.avatar.length > 1 && "me-1")}>
        <Avatar
          src={item.avatar[0]}
          name={item.name}
          className={cn(
            item.avatar.length > 1 &&
              "relative -end-1 -top-0.5 !h-9 !w-9"
          )}
        />
        {item.avatar.length > 1 && (
          <Avatar
            src={item.avatar[1]}
            name={item.name}
            className="absolute -bottom-1 end-1.5 !h-9 !w-9 border-2 border-gray-0 dark:border-gray-100"
          />
        )}
      </div>
      <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center">
        <div className="w-full">
          <Title as="h6" className="mb-0.5 text-sm font-semibold">
            {item.name}
          </Title>
          <div className="flex">
            <Text className="w-10/12 truncate pe-7 text-xs text-gray-500">
              {item.message}
            </Text>
            <span className="ms-auto whitespace-nowrap pe-8 text-xs text-gray-500">
              {dayjs(item.create_date).fromNow(true)}
            </span>
          </div>
        </div>
        <div className="ms-auto flex-shrink-0">
          {item.is_seen ? (
            <span className="inline-block rounded-full bg-gray-100 p-0.5 dark:bg-gray-50">
              <PiCheck className="h-auto w-[12px]" />
            </span>
          ) : (
            <Badge
              renderAsDot
              size="lg"
              color="info"
              className="scale-90"
            />
          )}
        </div>
      </div>
    </div>
  ))}
</div>}
</SimpleBar> */
}
